import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'

export const RichPlacement2Section = (): JSX.Element => {
  return (
    <Paper>
      <SectionHeader title={'RichPlacement2Section'} />
    </Paper>
  )
}
